import { render, staticRenderFns } from "./ShowResult.vue?vue&type=template&id=560053e2&scoped=true&"
import script from "./ShowResult.vue?vue&type=script&lang=js&"
export * from "./ShowResult.vue?vue&type=script&lang=js&"
import style0 from "./ShowResult.vue?vue&type=style&index=0&id=560053e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560053e2",
  null
  
)

export default component.exports